<template lang="pug">
  p.has-text-weight-normal {{reviewText}} 
    a(:href="reviewLink", target="_blank") {{linkText}}
</template>

<script>
  import brand from "@/brand";

  export default {
    data() {
      return {};
    },
    methods: {
    },
    computed: {
      reviewText() {
        const text = {
          "cybersmart" : "",
          "ftta"       : "FTTA | Fibre To The Apartment would love your feedback. Post a review to our ",
          "gigalight"  : "",
        };
        return text[brand.getBrand()];
      },
      reviewLink() {
        const links = {
          "cybersmart": "https://g.page/r/CY7n-qih1Cw-EBM/review",
          "ftta":       "https://g.page/r/CQXAkG1cf52WEAg/review",
          "gigalight":   "",
        }
        return links[brand.getBrand()];
      },
      linkText() {
        const links = {
          "cybersmart": "Please leave a review",
          "ftta":       "profile",
          "gigalight":   "",
        }
        return links[brand.getBrand()];
      }
    }
  }
</script>

<style lang="scss">
  @import "~bulma/sass/utilities/mixins";
  p {
    margin-bottom: 2rem;
  }

</style>